import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-68a86b5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "patch_info_cntr" }
const _hoisted_2 = {
  key: 0,
  class: "black-txt bold-txt kb_number"
}
const _hoisted_3 = {
  key: 1,
  class: "black-txt bold-txt kb_number"
}
const _hoisted_4 = { class: "gray-txt" }
const _hoisted_5 = {
  key: 2,
  class: "sub-desc-cntr"
}
const _hoisted_6 = { class: "gray-txt" }
const _hoisted_7 = {
  class: "file-list",
  style: {"margin-left":"-4px"}
}
const _hoisted_8 = { class: "format-size" }
const _hoisted_9 = { class: "format-os" }
const _hoisted_10 = { class: "down-side" }
const _hoisted_11 = {
  key: 0,
  class: "black-txt"
}
const _hoisted_12 = {
  key: 0,
  class: "leak-level"
}
const _hoisted_13 = {
  key: 1,
  class: "leak-level optional"
}
const _hoisted_14 = {
  key: 1,
  class: "black-txt"
}
const _hoisted_15 = { class: "black-txt" }

import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { PatchInfo } from '@/views/dashboard/safe-status/vulnerability-fix/vulnerability-fix.service'
import { resolvedVirusKbDescription } from '@/utils/virus-kb-description'


export default /*#__PURE__*/_defineComponent({
  __name: 'patch-info-panel',
  props: {
  patchInfo: {
    type: Object as PropType<PatchInfo>,
    default: () => ({} as PatchInfo)
  },
  warnLevel: {
    type: Number
  },
  /** 与列表「漏洞说明」列一致：接口 production 为空时用列表 kb_desc */
  descriptionFallback: {
    type: String,
    default: ''
  },
  /** 接口日期未返回时用列表 kb_pub_date */
  pubDateFallback: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const { t, te, locale } = useI18n()

const props = __props

const isCVE = computed(() => {
  return props.patchInfo.kb_number?.includes('CVE-')
})

const leakDescription = computed(() => {
  void locale.value
  const fromLocale = resolvedVirusKbDescription(props.patchInfo.kb_number, te, t)
  if (fromLocale) return fromLocale
  const p = props.patchInfo.production
  if (p != null && String(p).trim() !== '') return String(p)
  const f = props.descriptionFallback
  if (f != null && String(f).trim() !== '') return String(f)
  return t('safeProtectionModule.patchPopoverNoText')
})

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.patchInfo.kb_number && __props.patchInfo.kb_number.includes('CVE-'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('safeProtectionModule.patchPopoverNumberCve', { kb: __props.patchInfo.kb_number })), 1))
      : (__props.patchInfo.kb_number)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('safeProtectionModule.patchPopoverNumberKb', { kb: __props.patchInfo.kb_number })), 1))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('safeProtectionModule.patchPopoverPublishDate', { date: __props.patchInfo.patch_pub_date || __props.pubDateFallback || '—' })), 1),
    (__props.patchInfo.file_list?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.patchPopoverPatchSizeHeading')) + " ", 1),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.patchInfo.file_list, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.size
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.size), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(item.os), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_divider, { style: {"margin":"10px 0"} }),
    _createElementVNode("div", _hoisted_10, [
      (isCVE.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.patchPopoverLeakLevelHeading')) + " ", 1),
            (__props.warnLevel)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('safeProtectionModule.highRisk')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('safeProtectionModule.optional')), 1))
          ]))
        : _createCommentVNode("", true),
      (!isCVE.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('safeProtectionModule.patchPopoverSafeNotice', { text: __props.patchInfo.safe_notice || _ctx.$t('safeProtectionModule.patchPopoverNoText') })), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.patchPopoverLeakDescHeading')) + _toDisplayString(leakDescription.value) + " ", 1),
        (__props.patchInfo.official_page_url)
          ? (_openBlock(), _createBlock(_component_el_link, {
              key: 0,
              class: "link-desc",
              type: "primary",
              target: "_blank",
              href: __props.patchInfo.official_page_url
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.patchPopoverOfficialIntro')), 1)
              ]),
              _: 1
            }, 8, ["href"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})